import type { MinifiedTask } from '@gcv/shared';

export const getGroupedAccountNames = (tasks: MinifiedTask[]): string[] => {
  const names = tasks.map((task) => {
    if (task.assigned_org?.orgType === 'bank') {
      return task.account?.name ?? '--';
    }
    return task.assigned_org?.name ?? '--';
  });

  return [...new Set(names)];
};
